export const GOOGLE_PAGE_SIZE = 10;
